<template>
  <div v-if="this.loading != true && this.insurance && String(this.insurance).length > 0 && this.kpiData.length > 0">
    <v-data-iterator
      :items="reportData"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
          dark
          flat
          height="60"
          :hidden="hideToolbar"
          color="primary"
          class="mb-1"
        >
          <template>
            <v-select
              v-model="sortBy"
              flat
              dense
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-sort-variant"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle
              background-color="rgba(0,0,0,0)"
              v-model="sortDesc"
              mandatory
            >
              <v-btn color="secondary" height="40" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn color="secondary" height="40" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:no-data>
        <v-row class="px-4">
          <v-col class="text-center">No data available</v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-row class="px-4">
          <v-col
            v-for="item in props.items"
            :key="item.month"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            :xl="xlColWidth"
          >
            <v-card outlined>
              <v-card-title class="subheading font-weight-bold">{{
                item.month
              }}</v-card-title>
              <v-divider></v-divider>
              <v-list dense loading>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content
                    class="font-weight-bold"
                    :class="{ 'accent--text': sortBy === key }"
                    >{{ key }}:</v-list-item-content
                  >
                  <v-list-item-content
                   class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-if="revenueFields.includes(key) "
                    >
                    {{ (item[key.toLowerCase()] && item[key.toLowerCase()] !== 'No data')  ? `$${formatCurrency(item[key.toLowerCase()])}` : 'No Data' }}
                  </v-list-item-content>
                  <v-list-item-content
                   class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else-if="percentageFields.includes(key)"
                    >
                     {{ item[key.toLowerCase()]   ? `${formatNumber(item[key.toLowerCase()])} %` : 'No Data' }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else
                    >&nbsp;{{ ` ${item[key.toLowerCase()]}` }}</v-list-item-content
                  >
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="px-7 pt-2 pb-4" align="center" justify="center">
          <v-spacer></v-spacer>
          <span class="mr-4 grey--text"
            >Page {{ page }} of {{ numberOfPages }}</span
          >
          <v-btn
            small
            fab
            dark
            color="primary"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn small fab dark color="primary" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'kpi',
  props: [
    'organization',
    'group',
    'groupNum',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'hideToolbar',
    'runOnMounted',
    'xlColWidth', // needed for provider modal
    'kpiData'
  ],
  data() {
    return {
      search: '',
      load: true,
      sortDesc: false,
      itemsPerPageArray: [1, 2, 4, 6, 8, 12],
      page: 1,
      pagination: '',
      sortBy: 'Month',
      loading: false,
      keys: [
        'Month',
        'Membership',
        'MLR',
        'MRA',
        'Revenue',
        'Expenses',
        'ER Visits',
        'ER Visits Per 1000',
        'ER Visits Cost',
        'Admissions',
        'Admissions Cost',
        'Admits Per 1000',
        'Outpatient Costs',
        'Outpatient Visits',
        'Total Inpatient',
        'Average Stay',
        'Inpatient days per 1000',
        'Observations',
        'Observations Per 1000',
        'Brand Rx Count',
        'Brand Rx Cost',
        'All Rx Count',
        'Generic Rx Count',
        'GDR',
        'Readmissions',
        'Readmission Cost',
      ],
      revenueFields: [
        'Revenue',
        'Expenses',
        'ER Visits Cost',
        'Admissions Cost',
        'Outpatient Costs',
        'Brand Rx Cost',
         'Readmission Cost'
      ],
      percentageFields: [
        'MLR'
      ],
      reportData: [],
      headers: [],
      patients: [],
      cancelSource: null,
    };
  },
  computed: {
    // Get pages and key, value pairs
    numberOfPages() {
      return Math.ceil(this.reportData.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Month');
    },
    itemsPerPage: {
      get() {
        if (this.$vuetify.breakpoint.xl && this.xlColWidth == 2) {
          return 6;
        }
        if (this.$vuetify.breakpoint.xl && this.xlColWidth != 2) {
          return 4;
        }
        if (this.$vuetify.breakpoint.lgAndUp) {
          return 4;
        }
        if (this.$vuetify.breakpoint.mdAndUp) {
          return 3;
        }
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatCurrency(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },
  watch: {
    async kpiData() {
      this.kpiData.forEach((info) => {
        info.membership = info.membership ? info.membership : 'No data';
        info.mlr = info.mlr ? info.mlr : 'No data';
        info.mra = info.mra ? info.mra : 'No data';
        info['inpatient days per 1000'] = !isNaN(
          ((info['total inpatient'] / info.membership) * 1000).toFixed(2),
        )
          ? ((info['total inpatient'] / info.membership) * 1000).toFixed(2)
          : 'No Data';
        info.gdr = `${this.formatNumber(
          (info['generic rx count'] / info['all rx count']).toFixed(2),
        )}`;
        info['total inpatient'] = info['total inpatient']
          ? info['total inpatient']
          : 'No data';
        info.revenue = info.revenue
          ? info.revenue
          : 'No data';
        info.expenses = info.expenses
          ? info.expenses
          : 'No data';
        info['er visits'] = info['er visits']
          ? info['er visits']
          : 'No data';
        info['er visits cost'] = info['er visits cost']
          ? info['er visits cost']
          : 'No data';
        info['er visits per 1000'] = !isNaN(
          ((info['er visits'] / info.membership) * 1000).toFixed(2),
        )
          ? ((info['er visits'] / info.membership) * 1000).toFixed(2)
          : 'No Data';
        info.admissions = info.admissions
          ? this.formatNumber(info.admissions)
          : 'No data';
        info['admissions cost'] = info['admissions cost']
          ? info['admissions cost']
          : 'No data';
        info['admits per 1000'] = (info.admissions / info.membership) * (1000).toFixed(2)
          ? ((info.admissions / info.membership) * 1000).toFixed(2)
          : 'No Data';
        info['outpatient costs'] = info['outpatient costs']
          ? info['outpatient costs']
          : 'No data';
        info['outpatient visits'] = info['outpatient visits']
          ? info['outpatient visits']
          : 'No data';
        info['brand rx count'] = info['brand rx count']
          ? info['brand rx count']
          : 'No data';
        info['brand rx cost'] = info['brand rx cost']
          ? info['brand rx cost']
          : 'No data';
        info['all rx count'] = info['all rx count']
          ? info['all rx count']
          : 'No data';
        info['generic rx count'] = info['generic rx count']
          ? info['generic rx count']
          : 'No data';
        info.observations = info.observations ? info.observations : 0;
        info['observations per 1000'] = !isNaN(
          ((info.observations / info.membership) * (1000)).toFixed(2),
        )
          ? ((info.observations / info.membership) * 1000).toFixed(2)
          : 'No Data';
        info.readmissions = info.readmissions ? info.readmissions : 0;
        info['readmission cost'] = info['readmission cost']
          ? info['readmission cost']
          : 'No data';
        info['average stay'] = info['average stay'] ? info['average stay'] : 'No Data';
      });
      this.reportData = this.kpiData;
      this.loading = false;
    }
  }
};
</script>
